import React from "react";
import { NavLink } from "react-router-dom";
import Header4 from "../Common/Header4";
import Footer2 from "../Common/Footer2";
import Banner from "../Elements/Banner";
import { productsDetails } from "../../data";

var bnrimg = require("./../../images/page_banners/Banner1.JPEG");

class ShopGrid extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/custom.js");
  }
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Banner title="Rental Page" pagename="Rental Page" bgimage={bnrimg} />
          {/* SHOP SECTION START */}
          <div className="section-full p-t120 p-b90 bg-cream mobile-page-padding">
            <div className="container">
              {/* <div className="product-filter-wrap d-flex justify-content-between align-items-center m-b30">
                <div className="list-grid-control">
                  <NavLink to={"/rentals"} className="active">
                    <i className="fa fa-th" />
                  </NavLink>
                  <NavLink to={"/rentals-list"}>
                    <i className="fa fa-th-list" />
                  </NavLink>
                </div>
              </div> */}
              <div className="text-center clearfix filter-pos-right shadow m-b30">
                <ul className="btn-filter-wrap">
                  <h4 className="mb-0">
                    For prices please{" "}
                    <NavLink to={"/contact-us"}>Contact us </NavLink>{" "}
                  </h4>
                </ul>
              </div>
              <div className="row d-flex justify-content-center">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 m-b30">
                  <div className="row">
                    {productsDetails.map((item, index) => (
                      <div
                        key={item.title + index}
                        className="col-lg-6 col-md-6 m-b30"
                      >
                        <div className="sx-product-box  overflow-hide">
                          <div
                            className="sx-thum-bx sx-img-overlay"
                            // style={{ objectFit: "contain" }}
                          >
                            <img
                              src={item.image}
                              alt=""
                              // style={{ objectFit: "contain" }}
                            />
                          </div>
                          <div className="sx-info p-t20 text-center">
                            <h5 className="sx-title">
                              {/* <NavLink to={"/rental-detail/" + item.id}>
                                {item.title}
                              </NavLink> */}
                              {item.title}
                            </h5>
                            <p className="mb-2">{item.description} </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* SHOP SECTION END */}
        </div>

        <Footer2 />
      </>
    );
  }
}

export default ShopGrid;
